import { Component, OnInit } from '@angular/core'
// import { FormGroup, FormBuilder, Validators } from '@angular/forms'
// import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
// import { ApiService } from '../api.service'
import { UserService } from '../user.service'
// import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router'

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss']
})

export class ReportsComponent implements OnInit {
    // form: FormGroup;
    isLoaded = true
    isLoading = false
    loadingError = false
    displayHelpMessage = false
    errorMsg = ""

    constructor(
        // private fb: FormBuilder,
        private userService: UserService,
        // private apiService: ApiService,
        private router: Router,
        // private spinner: NgxSpinnerService,
    ) {
        this.prepareForm()
    }

    ngOnInit() {
        if ( !this.userService.isAdmin ) {
            this.userService.deny();
            return;
        }
    }

    prepareForm(){

    }

    go_back(){
        this.router.navigate(['/admin/courses-and-events'])
    }

    get isAuthorized(){
        return this.userService.isAuthorized;
    }

}